export default {
    namespaced: true,

    state: {
        following: false,
    },

    mutations: {
        CHANGE_STATUS(state, status){
            state.following = status;
        },
    },

    actions: {
        follow(context, params){
            if(Object.keys(params.currentUser).length){
                var data = JSON.stringify({
                    "user_uid": params.currentUser.mp_id,
                    'status': 'POST',
                    'curtindo': !context.state.following,
                    "artista": params.artist.artista_url
                });
    
                var config = {
                    method: 'post',
                    url: 'https://api.musicpro.live:55001/api/curtir/',
                    headers: { 
                        'x-access-token': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjp7Il9pZCI6IjVlMWZkNzg5OGNhMjAzNjZmYzY1ZTQ4OCIsIm5vbWUiOiJsb2wiLCJlbWFpbCI6ImxvbEB0ZXN0ZS5jb20uYnIifSwiaWF0IjoxNTgyODU5NzY1fQ.hkhWAs5UfXK1hzI2h0uPFGVHpEaocu9jwliQLPKru4s', 
                        'Content-Type': 'application/json'
                    },
                    data : data
                };
    
                axios(config).then(function (response) {
                    context.commit('CHANGE_STATUS', response.data.curtindo);
                }).catch(function (error) {
                    console.log(error);
                });
            }
        },

        checkStatus(context, params){
            if(Object.keys(params.currentUser).length){
                var data = JSON.stringify({
                    "user_uid": params.currentUser.mp_id,
                    'status': 'GET',
                    "artista": params.artist.artista_url
                });

                var config = {
                    method: 'post',
                    url: 'https://api.musicpro.live:55001/api/curtir/',
                    headers: { 
                        'x-access-token': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjp7Il9pZCI6IjVlMWZkNzg5OGNhMjAzNjZmYzY1ZTQ4OCIsIm5vbWUiOiJsb2wiLCJlbWFpbCI6ImxvbEB0ZXN0ZS5jb20uYnIifSwiaWF0IjoxNTgyODU5NzY1fQ.hkhWAs5UfXK1hzI2h0uPFGVHpEaocu9jwliQLPKru4s', 
                        'Content-Type': 'application/json'
                    },
                    data : data
                };

                axios(config).then(function (response) {
                    context.commit('CHANGE_STATUS', response.data.curtindo);
                }).catch(function (error) {});
            }
        },
    }
}